<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <overview-departure-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <departure-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import OverviewDepartureSideNav from "./components/OverviewDepartureSideNav.vue"
import DepartureDetail from "./components/DepartureOverview.vue"

export default {
    name: 'Departure_overview_page',
    components: {
        OverviewDepartureSideNav,
        DepartureDetail
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {        
    },
}
</script>